import {useCallback} from 'react';
import {IS_CLIENT} from '../../common/constant';
import useLocalStorageMap from '../../common/hook/useLocalStorageMap';
import {getLocalStorageObject} from '../../common/util/storage';
import {VIEWER_LS_KEY_PROGRESS_RATIO} from '../../commonSub/constant';
import {getViewerLsMapKey} from '../common';

export default function useProgressRatio({
  contentId,
  episodeId,
}: {
  contentId?: number;
  episodeId: number;
}): {ratio?: number; saveProgressRatio: (ratio: number) => void} {
  const [progressMap, mergeProgressRatio] = useLocalStorageMap<number>({
    key: VIEWER_LS_KEY_PROGRESS_RATIO,
    needDebounce: true,
  });

  const saveProgressRatio = useCallback(
    (ratio: number) => {
      contentId &&
        mergeProgressRatio({
          [getViewerLsMapKey(contentId, episodeId)]: ratio,
        });
    },
    [contentId, episodeId, mergeProgressRatio]
  );

  return {
    ratio: contentId ? progressMap[getViewerLsMapKey(contentId, episodeId)] : 0,
    saveProgressRatio,
  };
}

export function getProgressRatio(contentId: number, episodeId: number) {
  if (IS_CLIENT) {
    const ratioMap = getLocalStorageObject<{[key: string]: number}>({
      key: VIEWER_LS_KEY_PROGRESS_RATIO,
    });
    return ratioMap?.[getViewerLsMapKey(contentId, episodeId)];
  }
}
